export default "__VITE_PUBLIC_ASSET__798aa3c7__"